// @flow
import React, { memo } from 'react';
import { Replay as ReplayIcon } from '@material-ui/icons';

type Props = Object;

const Replay = (props: Props) => <ReplayIcon {...props} />;

export default memo<Props>(Replay);
